const STORAGE_KEY = 'app/translations';

export default {
  STORAGE_KEY
}
